import { dataHooks } from '@wix/data-hooks'

export const returningUserSplitDataHooks = dataHooks<{
  subtitle: {}
  title: {}
  optionTitle: { optionKey: string }
  optionCta: { optionKey: string }
  secondaryOptionCta: { optionKey: string }
}>('returning-user-split')
